import React from "react";
import pandaImage from "../../../../../assets/UnmetNeedsIntroPanda.png"; 
import { FaCircleChevronRight } from "react-icons/fa6";

const UnmetNeedsIntro = ({ onGetStarted }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 py-10 bg-white text-center">
      
      {/* Panda Image */}
      <img
        src={pandaImage}
        alt="Panda character"
        className="w-60 sm:w-72 md:w-80 lg:w-96 h-auto mb-6 object-contain"
      />

      {/* Description Text */}
      <p className="max-w-lg text-[#323232] text-sm sm:text-base font-gotham font-normal leading-relaxed mb-8">
        Let’s identify the needs that aren’t fully met at work — <br className="hidden sm:block" />
        so we know what must change for you to grow.
      </p>

      {/* Button */}
      <button
        onClick={onGetStarted}
        className="bg-[#54B0AF] hover:bg-teal-600 text-white font-medium text-base sm:text-xl font-gotham px-8 py-3 rounded-2xl md:rounded-[20px] shadow-md transition-all duration-300 flex items-center gap-2"
      >
        Get Started
        <FaCircleChevronRight className="w-5 h-5 ml-4 text-base" />
      </button>
    </div>
  );
};

export default UnmetNeedsIntro;